import { Box, Typography, useTheme } from "@outschool/backpack";
import { TeacherVideoModal_TeacherFragment } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import {
  Carousel,
  Container,
  Loading,
} from "@outschool/ui-legacy-component-library";
import { useIsMobile } from "@outschool/ui-utils";
import React from "react";

import { TeacherVideoModal } from "../ClassDetailsPage/TeacherVideoModal";
import { useTutorData } from "./hooks/useTutorData";
import { TutorCard } from "./TutorCard";
import { TutorCardSkeleton } from "./TutorCardSkeleton";

export const TutorVideoCarousel = () => {
  const { t } = useTranslation(
    "ui-components-website\\Teachers\\TutorVideoCarousel"
  );
  const {
    tutors,
    loading,
    selectedTeacher,
    setSelectedTeacher,
    handleNextTeacher,
    handlePreviousTeacher,
  } = useTutorData();
  const isMobile = useIsMobile();
  const { breakpoints } = useTheme();

  return (
    <>
      <Container>
        <Typography variant="h3">{t`Meet our tutors`}</Typography>
      </Container>
      <Container
        fullBleed={isMobile}
        sx={{
          padding: "10px",
          [breakpoints.up("md")]: { padding: "10px 0px" },
        }}
      >
        <Carousel sx={{ margin: "-10px" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 12,
              padding: 16,
              [breakpoints.up("md")]: { padding: 10 },
            }}
          >
            {loading
              ? Array.from({ length: 10 }, (_, index) => (
                  <TutorCardSkeleton key={index} />
                ))
              : tutors.map((tutor: TeacherVideoModal_TeacherFragment) => (
                  <TutorCard
                    key={tutor.uid}
                    leader={tutor}
                    onClick={() => setSelectedTeacher(tutor)}
                  />
                ))}
          </Box>
        </Carousel>
      </Container>
      {selectedTeacher && (
        <React.Suspense fallback={<Loading />}>
          <TeacherVideoModal
            isOpen={!!selectedTeacher}
            onClose={() => setSelectedTeacher(null)}
            teacher={selectedTeacher}
            onNext={handleNextTeacher}
            onPrevious={handlePreviousTeacher}
          />
        </React.Suspense>
      )}
    </>
  );
};
